import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import { getUserData } from "../../../actions/user";
import UserHeader from "../../../components/Library/UserHeader";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import SummaryCard from "../../../components/Library/SummaryCard/SummaryCard";
import SavedStoriesEmpty from "./SavedStoriesEmpty";

import styles from "../UserSettings/UserSettings.css";

class SavedStories extends Component {
  componentDidMount() {
    this.props.getUserData();
  }

  render() {
    return (
      <Layout className={styles.root} includeHeader={true} headerComponent={<UserHeader person={{ display_name: this.props.userSettings.data.profileInfo.display_name }} />}>
        <Sidebar className={styles.sidebar}>
          <Link to="/users/saved-stories" className={classNames(styles.sidebarLinks, styles.active)}>
            Saved Stories
          </Link>
          <Link to="/users/settings" className={styles.sidebarLinks}>
            Account
          </Link>
        </Sidebar>
        <Content>
          {this.props.userSettings.data.profileInfo.saved_stories.map((savedStory, index) => {
            return (
              <SummaryCard key={index} story={savedStory} showSaveTag={true} />
            );
          }) }

          {this.props.userSettings.data.profileInfo.saved_stories.length === 0 ? <SavedStoriesEmpty /> : null}
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSettings: state.userSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserData: bindActionCreators(getUserData, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedStories);



// WEBPACK FOOTER //
// ./src/users/components/SavedStories/SavedStories.js